var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processo
    ? _c(
        "div",
        { staticClass: "cardInformacoes card" },
        [
          _vm.showSincronizar
            ? _c("Vincular-Pessoa", {
                attrs: { processo: _vm.processo },
                on: {
                  cancelar: function($event) {
                    _vm.showSincronizar = false
                  },
                  atualizarProcesso: _vm.atualizarProcesso
                }
              })
            : _vm._e(),
          _vm.visualizarModalRetificacao
            ? _c("app-modal-retificacao-cadastro", {
                attrs: { idProcesso: _vm.processo.id },
                on: { closeModal: _vm.closeModal }
              })
            : _vm._e(),
          _vm.showModalVisualizarProcesso
            ? _c("app-modal-visualizar-completo", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  protocolo: _vm.protocolo,
                  numeroProcesso: _vm.numeroProcesso,
                  tipo: _vm.tipoProcesso,
                  isCentralInteressado: true
                },
                on: {
                  closeModal: function($event) {
                    return _vm.closeModalVisualizar()
                  }
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "card-header" },
            [
              _vm._v("Informações do cadastro"),
              _vm.isInteressado && _vm.switchHabilitar
                ? _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "containerBotaoHabilitar" }, [
                      _c(
                        "div",
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.isAmapa()
                                  ? "Habilitar visualização do processo ao cadastrante"
                                  : "Habilitar cadastrante"
                              )
                            )
                          ]),
                          _c("p"),
                          _c("el-switch", {
                            attrs: { "active-color": "#13ce66" },
                            on: { change: _vm.ativarDesativar },
                            model: {
                              value: _vm.isSwitchAtivado,
                              callback: function($$v) {
                                _vm.isSwitchAtivado = $$v
                              },
                              expression: "isSwitchAtivado"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "marginTop" },
                [
                  !_vm.isCadastroPendente
                    ? _c(
                        "el-dropdown",
                        { attrs: { trigger: "click" } },
                        [
                          _c(
                            "el-button",
                            { attrs: { type: "info", size: "small" } },
                            [
                              _vm._v("Opções"),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              !_vm.downloadCcr && _vm.showButtonOficio
                                ? _c(
                                    "el-dropdown-item",
                                    { class: { disabled: !_vm.downloadCcr } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.emitirOficioCcr()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "center" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "fal fa-download"
                                                },
                                                [
                                                  _vm._v(
                                                    "  Ofício cancelamento de cláusula resolutiva"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("el-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex",
                                    on: {
                                      click: _vm.emitirSegundaVia,
                                      emitirSegundaVia: function($event) {
                                        return _vm.emitirSegundaVia()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "center" }, [
                                      _c("i", {
                                        staticClass: "fal fa-download"
                                      }),
                                      _vm._v(
                                        "  Segunda via do comprovante de envio"
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm.isRetificaoCadastro()
                                ? _c("el-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex",
                                        on: { click: _vm.openModal }
                                      },
                                      [
                                        _c("span", { staticClass: "center" }, [
                                          _c("i", {
                                            staticClass: "fal fa-sync-alt"
                                          }),
                                          _vm._v("  Retificar Cadastro")
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm.showRetificacaoCadastroOnline()
                                ? _c("el-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex",
                                        on: { click: _vm.navigateToCadastro }
                                      },
                                      [
                                        _c("span", { staticClass: "center" }, [
                                          _c("i", {
                                            staticClass: "fal fa-sync-alt"
                                          }),
                                          _vm._v("  Retificar Cadastro Online")
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm.isShowVincularPessoa() &&
                              _vm.visualizarBotaoVincularPessoa
                                ? _c("el-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex",
                                        on: {
                                          click: function($event) {
                                            _vm.showSincronizar = true
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "center" }, [
                                          _c("i", {
                                            staticClass: "fal fa-sync-alt"
                                          }),
                                          _vm._v("  Vincular pessoa")
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm.visualizaProcesso
                                ? _c("el-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex",
                                        on: { click: _vm.visualizarProcesso }
                                      },
                                      [
                                        _c("span", { staticClass: "center" }, [
                                          _c("i", {
                                            staticClass: "fal fa-eye"
                                          }),
                                          _vm._v("  Visualizar Processo")
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm.isMaranhao() &&
                              (_vm.isCacelamentoDeClausulaResolutiva() ||
                                _vm.isProcessoFisico())
                                ? _c("el-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex",
                                        on: { click: _vm.retificararProcesso }
                                      },
                                      [
                                        _c("span", { staticClass: "center" }, [
                                          _c("i", {
                                            staticClass: "fal fa-sync-alt"
                                          }),
                                          _vm._v("  Retificar Processo")
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm.isAmapa() && _vm.isInteressado
                                ? _c("el-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex",
                                        on: { click: _vm.solicitarCopia }
                                      },
                                      [
                                        _c("span", { staticClass: "center" }, [
                                          _c("i", {
                                            staticClass: "fal fa-file"
                                          }),
                                          _vm._v(
                                            "  Solicitar cópia do processo"
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.getIsOnline()
                ? _c("cadastro-online", {
                    attrs: {
                      processo: _vm.processo,
                      idProcesso: _vm.processo.id
                    }
                  })
                : _c("cadastro-offline", {
                    attrs: {
                      processo: _vm.processo,
                      isCadastroPendente: _vm.isCadastroPendente
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-758a570b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758a570b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformacoesCadastro.vue
// module id = null
// module chunks = 